module.exports = __webpack_public_path__ + "img/productionBase_12.b1261231.png";